module.exports = __webpack_public_path__ + "static/img/NL.4c21204.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/certified_shipping/NL.png
// module id = ZoX4
// module chunks = 2